import Icons from "../../assets/icon";
import { IoIosArrowRoundBack } from "react-icons/io";
import localimgpath from "../../js/localimgpath";
import {
  SmAnimatespin,
  CheckBoxSelection,
  Dropdown,
  EmpApplicantslistCom,
  SearchbarCom,
  SidenavbarCom,
  Pagination,
  Button,
  Text,
} from "../../components/index";
import RangeSlider from "react-range-slider-input";
import Functions from "./index.function.js";
import { fontSizes } from "../../constants/constants.js";
import { Link } from "react-router-dom";
const EmpApplicantsList = () => {
  const {
    loadingJobStatusapi,
    loadingJobStatusRejected,
    loadingJobStatusSaved,
    isLoading,
    appliedJobData,
    has_more_pages,
    total_pages,
    setCurrentPage,
    currentPage,
    activeTab,
    setActiveTab,
    setShowPopup,
    showPopup,
    filterPopup,
    setFilterPopup,
    dropdowns,
    dropdownLoading,
    register,
    handleSubmit,
    control,
    errors,
    handleDropdwonSelect,
    select,
    states,
    isLoadingStates,
    cities,
    citiesisLoading,
    rangeHeight,
    tooltipPosHeight,
    sliderRefHeight,
    handleInputHeight,
    rangeWeight,
    tooltipPosWeight,
    sliderRefWeight,
    handleInputWeight,
    rangeAge,
    tooltipPosAge,
    sliderRefAge,
    handleInputAge,
    onSubmit,
    resetFilters,
    formatDate,
    RadioValueandLable,
    handleStartChat,
    userData,
    savedJobs,
    handleJobStatusUpdate,
    handleJobStatusRejectedUpdate,
    handleJobStatusSavedUpdate,
    baseURL,
    mutationJobStatus,
    loading,
    setValueJobslisting,
    valuejobslisting,
    TextWeight
  } = Functions();
  return (
    <div className="h-screen w-full flex flex-col bg-[#000000]">
      {/* Navbar */}
      <SearchbarCom />
      <div className="grid grid-cols-none sm:grid-cols-7 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
        {/* Left Sidebar */}
        <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
          <SidenavbarCom />
        </div>

        {/* Center Content (Scrollable) */}
        <div className="grid-cols-none sm:col-span-5 overflow-hidden h-[calc(100vh-4rem)]">
          <div className={` w-full xs:px-1 sm:pl-4 lg:pl-5 h-full pt-2 pb-1`}>
            <div className="flex flex-col relative w-full h-full bg-[#1A1A1A] px-[2px] sm:px-3 lg:px-5 rounded-lg">
              <div className="flex items-center flex-wrap justify-between py-5 sm:py-10">
                <h1 className="text-white xs:text-xs sm:text-sm lg:text-4xl font-onestSemiBold">
                  {appliedJobData?.job_applies?.[0]?.job?.title}
                </h1>
                <div className="flex justify-start items-center gap-3">
                  <div
                    className="bg-[#2A2A2A] p-1 sm:p-3 rounded-full"
                    onClick={() => {
                      setFilterPopup(true);
                      setShowPopup(false);
                    }}
                  >
                    <img
                      src={Icons.filtersIcons}
                      alt="filtersIcons"
                      className="xs:w-4 xs:h-4 sm:w-6 sm:h-6 lg:w-7 lg:h-7"
                    />
                  </div>
                  <div className="flex items-center bg-[#2A2A2A] xs:gap-x-1 gap-x-2 p-1 rounded-full">
                    <button
                      onClick={() => setActiveTab("Pending")}
                      type={"button"}
                      className={`group xs:w-18 xs:h-8 sm:w-22 sm:h-10 lg:w-36 ${activeTab === "Pending" ? `gradient-container_btn` : ""
                        } xl:w-40 cursor-pointer bg-cover flex lg:h-10 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:shadow-lg`}
                    >
                      <p
                        className={`text-secondary font-onestRegular xs:text-[10px] sm:text-xs lg:text-sm xl:text-base `}
                      >
                        Pending Requests
                      </p>
                    </button>
                    <button
                      onClick={() => setActiveTab("Accepted")}
                      type={"button"}
                      className={`group xs:w-18 xs:h-8 sm:w-22 sm:h-10 lg:w-36 ${activeTab === "Accepted" ? `gradient-container_btn` : ""
                        } xl:w-40 cursor-pointer bg-cover flex lg:h-10 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:shadow-lg`}
                    >
                      <p
                        className={`text-secondary font-onestRegular xs:text-[10px] sm:text-xs lg:text-sm xl:text-base `}
                      >
                        Approved Requests
                      </p>
                    </button>
                    <button
                      onClick={() => setActiveTab("Saved")}
                      type={"button"}
                      className={`group xs:w-20 xs:h-8 sm:w-28 sm:h-10 lg:w-36 ${activeTab === "Saved" ? `gradient-container_btn` : ""
                        } xl:w-40 cursor-pointer bg-cover flex lg:h-10 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:shadow-lg`}
                    >
                      <p
                        className={`text-secondary font-onestRegular xs:text-[10px] sm:text-xs lg:text-sm xl:text-base `}
                      >
                        Saved Requests
                      </p>
                    </button>
                    <button
                      onClick={() => setActiveTab("Rejected")}
                      type={"button"}
                      className={`group xs:w-20 xs:h-8 sm:w-28 sm:h-10 lg:w-36 ${activeTab === "Rejected" ? `gradient-container_btn` : ""
                        } xl:w-40 cursor-pointer bg-cover flex lg:h-10 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:shadow-lg`}
                    >
                      <p
                        className={`text-secondary font-onestRegular xs:text-[10px] sm:text-xs lg:text-sm xl:text-base `}
                      >
                        Rejected Request
                      </p>
                    </button>
                  </div>
                </div>
              </div>
              <div className="flex-1 overflow-y-auto dashboard-scrollbar xs:pr-1 sm:pr-2">
                {activeTab === "Pending" && (
                  <div className="">
                    <EmpApplicantslistCom
                      title={[
                        "Stage Name",
                        "Real Name",
                        "Age",
                        "Gender",
                        "Ethnicity",
                        "Country",
                        "Actions",
                      ]}
                      data={appliedJobData?.job_applies}
                      setFilterPopup={setFilterPopup}
                      setValueJobslisting={setValueJobslisting}
                      setShowPopup={setShowPopup}
                      loadingJobStatusapi={loadingJobStatusapi}
                      loadingJobStatusRejected={loadingJobStatusRejected}
                      savedJobs={savedJobs}
                      isLoading={isLoading}
                      handleJobStatusUpdate={handleJobStatusUpdate}
                      handleJobStatusSavedUpdate={handleJobStatusSavedUpdate}
                      handleJobStatusRejectedUpdate={
                        handleJobStatusRejectedUpdate
                      }
                      loadingJobStatusSaved={loadingJobStatusSaved}
                      formatDate={formatDate}
                      handleStartChat={handleStartChat}
                      loading={loading}
                      requestTitle={"Pending Requests"}
                    />
                  </div>
                )}

                {activeTab === "Accepted" && (
                  <div className=" ">
                    <EmpApplicantslistCom
                      title={[
                        "Stage Name",
                        "Real Name",
                        "Age",
                        "Gender",
                        "Ethnicity",
                        "Country",
                        "Actions",
                      ]}
                      data={appliedJobData?.job_applies}
                      setFilterPopup={setFilterPopup}
                      setValueJobslisting={setValueJobslisting}
                      setShowPopup={setShowPopup}
                      loadingJobStatusapi={loadingJobStatusapi}
                      loadingJobStatusRejected={loadingJobStatusRejected}
                      savedJobs={savedJobs}
                      isLoading={isLoading}
                      formatDate={formatDate}
                      handleStartChat={handleStartChat}
                      loading={loading}
                      requestTitle={"approved requests"}
                    />
                  </div>
                )}

                {activeTab === "Saved" && (
                  <div className=" ">
                    <EmpApplicantslistCom
                      title={[
                        "Stage Name",
                        "Real Name",
                        "Age",
                        "Gender",
                        "Ethnicity",
                        "Country",
                        "Actions",
                      ]}
                      data={appliedJobData?.job_applies}
                      setFilterPopup={setFilterPopup}
                      setValueJobslisting={setValueJobslisting}
                      setShowPopup={setShowPopup}
                      loadingJobStatusapi={loadingJobStatusapi}
                      loadingJobStatusRejected={loadingJobStatusRejected}
                      savedJobs={savedJobs}
                      isLoading={isLoading}
                      formatDate={formatDate}
                      handleStartChat={handleStartChat}
                      handleJobStatusUpdate={handleJobStatusUpdate}
                      handleJobStatusSavedUpdate={handleJobStatusSavedUpdate}
                      handleJobStatusRejectedUpdate={
                        handleJobStatusRejectedUpdate
                      }
                      loading={loading}
                      requestTitle={"saved requests"}
                    />
                  </div>
                )}

                {activeTab === "Rejected" && (
                  <div className=" ">
                    <EmpApplicantslistCom
                      title={[
                        "Stage Name",
                        "Real Name",
                        "Age",
                        "Gender",
                        "Ethnicity",
                        "Country",
                        "Actions",
                      ]}
                      data={appliedJobData?.job_applies}
                      setFilterPopup={setFilterPopup}
                      setValueJobslisting={setValueJobslisting}
                      setShowPopup={setShowPopup}
                      loadingJobStatusapi={loadingJobStatusapi}
                      loadingJobStatusRejected={loadingJobStatusRejected}
                      savedJobs={savedJobs}
                      isLoading={isLoading}
                      formatDate={formatDate}
                      handleStartChat={handleStartChat}
                      handleJobStatusUpdate={handleJobStatusUpdate}
                      loading={loading}
                      requestTitle={"approved requests"}
                    />
                  </div>
                )}
              </div>
              {/* Popup Modal */}
              <div
                className={`fixed top-0 right-0 z-50 w-full sm:w-9/12 lg:w-7/12 xl:w-1/3 bg-[#0F0F0F] xs:py-3 xs:px-2 sm:px-3 sm:py-4 lg:px-4 lg:py-5 h-full ${showPopup ? "translate-x-0" : "translate-x-full"
                  } transition-transform duration-300 ease-in-out`}
              >
                <div className="flex justify-center items-start flex-col relative h-full">
                  <div
                    className={`group flex cursor-pointer justify-center items-center xs:px-1.5 sm:px-3 lg:px-5 xs:py-[1.5px] sm:py-1 bg-[#2A2A2A] xs:rounded-md sm:rounded-lg transition-transform duration-300 transform hover:scale-105`}
                    onClick={() => setShowPopup(false)}
                  >
                    <IoIosArrowRoundBack className="text-secondary sm:text-2xl transition-colors duration-300 group-hover:text-orangeCrayola" />
                    <p className="text-secondary font-onestRegular xs:text-xs sm:text-sm lg:text-sm transition-colors duration-300 group-hover:text-secondary">
                      Back
                    </p>
                  </div>
                  <div className="text-center w-full xs:pt-1.5 xs:pb-2.5 sm:py-3.5 lg:pb-5">
                    <h2 className="text-secondary  font-unboundedBold uppercase xs:text-xs sm:text-lg lg:text-xl xl:text-2xl xs:mb-3 sm:mb-3.5 lg:mb-4">
                      Talent Details
                    </h2>
                    <div className="border-[3px] rounded-full mx-auto xs:w-32 xs:h-32 sm:w-36 sm:h-36 lg:w-40 lg:h-40 border-goldMetallic overflow-hidden">
                      <img
                        src={`${localimgpath?.talentThumbnail}/${valuejobslisting?.talent?.hero_image}`}
                        className="w-full h-full"
                        alt="Talent Details"
                      />
                    </div>
                  </div>
                  <div className="w-full flex-1 overflow-y-auto dashboard-scrollbar sm:pr-2 pr-1">
                    <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                          Stage Name:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {valuejobslisting?.talent?.stage_name}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Real Name:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {valuejobslisting?.talent?.real_name}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Age:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {valuejobslisting?.talent?.age}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Gender:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {valuejobslisting?.talent?.gender?.gender}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Ethnicity:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {valuejobslisting?.talent?.ethnicity?.name}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Country:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {valuejobslisting?.talent?.country?.country}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                          City:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {valuejobslisting?.talent?.city?.city}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Provinces:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {valuejobslisting?.talent?.state?.state}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular flex items-center text-secondary lg:gap-x-4">
                          Phone <br />
                          Number:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {valuejobslisting?.talent?.mobile_number}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                      <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Social Media Profiles:
                        </p>
                      </div>
                      <div className="xs:gap-x-2 xs:gap-y-2 sm:gap-x-3 sm:gap-y-3 flex items-center flex-wrap">
                        {valuejobslisting?.talent?.social_media?.map(
                          (value, index) => {
                            return (
                              <a
                                href={value?.social_media_link}
                                target="_blank"
                                key={index}
                                className="bg-[#2A2A2A] xs:px-3 xs:py-1 sm:px-3 sm:py-1 xs:rounded-md sm:rounded-lg text-[#B4B4B4] xs:!text-[8px] sm:text-xs lg:text-sm"
                              >
                                <p>{value?.social_media_link}</p>
                              </a>
                            );
                          }
                        )}
                      </div>
                    </div>
                    <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                      <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Website (URL):
                        </p>
                      </div>
                      <div className="xs:gap-x-2 xs:gap-y-2 sm:gap-x-3 sm:gap-y-3 flex items-center flex-wrap">
                        <Link
                          href={valuejobslisting?.talent?.your_website || "#"}
                          target="_blank"
                          rel="noopener noreferrer" className="bg-[#2A2A2A] xs:px-3 xs:py-1 sm:px-3 sm:py-1 xs:rounded-md sm:rounded-lg text-[#B4B4B4] xs:!text-[8px] sm:text-xs lg:text-sm">
                          <p>{valuejobslisting?.talent?.your_website}</p>
                        </Link>
                      </div>
                    </div>
                    {
                      valuejobslisting?.talent?.off_screen ? ("") : (<>
                        <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                              Hair Type:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.talent?.hair_type?.name}
                              </span>
                            </p>
                          </div>
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Eye Color:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.talent?.eye_color?.name}
                              </span>
                            </p>
                          </div>
                        </div>

                        <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Height:
                              {valuejobslisting?.talent?.height != null &&
                                valuejobslisting?.talent?.height !== "null" && (
                                  <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                    {valuejobslisting?.talent?.height} {" cm"}
                                  </span>
                                )}
                            </p>
                          </div>
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Weight:
                              {valuejobslisting?.talent?.weight != null &&
                                valuejobslisting?.talent?.weight !== "null" && (
                                  <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                    {valuejobslisting?.talent?.weight} {" kg"}
                                  </span>
                                )}
                            </p>
                          </div>
                        </div>
                        <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base flex items-center font-onestRegular text-secondary">
                              Body
                              <br />
                              Modifications
                              <br />/ Tattoos :
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.talent?.tattoos === 1
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </p>
                          </div>
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base flex items-center font-onestRegular text-secondary">
                              Body
                              <br />
                              Modifications
                              <br />/ Piercings :
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.talent?.piercings === 1
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </p>
                          </div>
                        </div>
                      </>
                      )
                    }
                    <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                      {/* <div>
                                                <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">Sexual Orientation:
                                                    <span className='xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm'>
                                                        {valuejobslisting?.talent?.sexual_orientation?.name}
                                                    </span>
                                                </p>
                                            </div> */}
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base flex items-center font-onestRegular text-secondary">
                          Desired Job:
                          {valuejobslisting?.talent?.desired_job_types?.map(
                            (job, index) => (
                              <span
                                key={index}
                                className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm"
                              >
                                {job?.title}
                              </span>
                            )
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Experience Level:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {
                              valuejobslisting?.talent?.experience_level
                                ?.job_experience
                            }
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base flex items-center font-onestRegular text-secondary">
                          Comments
                          <br />/ Qualifications:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {valuejobslisting?.talent?.qualification}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Languages Spoken:
                          {valuejobslisting?.talent?.languages_spoken?.map(
                            (lang, index) => (
                              <span
                                key={index}
                                className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm"
                              >
                                {lang?.lang}
                              </span>
                            )
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                  {activeTab === "Accepted" ? (
                    ""
                  ) : (
                    <div className=" xs:text-[8px] py-2 sm:text-xs lg:text-sm xl:text-base flex xs:gap-1 xs:pt-1 sm:pt-2 lg:pt-3 w-full sm:gap-2 lg:gap-3 justify-center">
                      <div
                        className={`bg-rejected xs:py-1.5 xs:px-11 sm:px-12 sm:py-2 lg:px-12 xl:px-16 ${loadingJobStatusRejected ? "lg:py-2" : "lg:py-1"
                          } rounded-full cursor-pointer`}
                        onClick={() => {
                          handleJobStatusRejectedUpdate(
                            valuejobslisting?.talent?.id,
                            "Rejected"
                          );
                        }}
                      >
                        <p className="xs:text-[8px] sm:text-xs lg:text-sm xl:text-base font-onestRegular text-secondary">
                          {loadingJobStatusRejected ? (
                            <SmAnimatespin />
                          ) : (
                            "Reject"
                          )}
                        </p>
                      </div>
                      <div
                        className={`bg-accepted xs:py-1.5 xs:px-11 sm:px-12 sm:py-2 lg:px-12 xl:px-16  ${loadingJobStatusapi ? "lg:py-2" : "lg:py-1"
                          } rounded-full cursor-pointer`}
                        onClick={() => {
                          handleJobStatusUpdate(
                            valuejobslisting?.talent?.id,
                            "Accepted"
                          );
                        }}
                      >
                        <p className="xs:text-[8px] sm:text-xs lg:text-sm xl:text-base font-onestRegular text-secondary">
                          {loadingJobStatusapi ? <SmAnimatespin /> : "Accept"}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div
                className={`fixed top-0 right-0 z-50 w-full sm:w-9/12 lg:w-7/12 xl:w-1/3 bg-[#0F0F0F] xs:py-3 xs:px-4 sm:px-3 sm:py-4 lg:px-4 lg:py-5 h-screen transition-transform duration-300 ease-in-out ${filterPopup ? "translate-x-0" : "translate-x-full"
                  }`}
              >
                <form
                  className="flex flex-col h-full w-full"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  {/* Header */}
                  <div className="w-full">
                    <div
                      className={`group flex cursor-pointer justify-center items-center xs:px-1.5 sm:px-3 w-fit lg:px-5 xs:py-[1.5px] sm:py-1 bg-[#2A2A2A] xs:rounded-md sm:rounded-lg transition-transform duration-300 transform hover:scale-105`}
                      onClick={() => setFilterPopup(false)}
                    >
                      <IoIosArrowRoundBack className="text-secondary sm:text-2xl transition-colors duration-300 group-hover:text-orangeCrayola" />
                      <p className="text-secondary font-onestRegular xs:text-xs sm:text-sm lg:text-sm transition-colors duration-300 group-hover:text-secondary">
                        Back
                      </p>
                    </div>
                    <div className="text-center w-full xs:pt-4 xs:pb-5 sm:pt-7 sm:pb-7 lg:pb-10">
                      <h2 className="text-secondary font-unboundedBold uppercase xs:text-xs sm:text-lg lg:text-xl xl:text-4xl">
                        Talent Filter
                      </h2>
                    </div>
                  </div>

                  {/* Scrollable Form Section */}
                  <div className="flex-1 overflow-y-auto dashboard-scrollbar  sm:pr-2 pr-1">
                    <div className="flex flex-col justify-start items-center w-full gap-4">
                      <div
                        className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4 "}
                      >
                        <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                          <Dropdown
                            control={control}
                            label={"Country"}
                            options={dropdowns?.country}
                            valueName="country"
                            valueoption="country_id"
                            name={"countries"}
                            rightIcon={Icons.arrowIcon}
                            selectedValue={select.country}
                            handleSelect={(value) =>
                              handleDropdwonSelect("country", value)
                            }
                            errors={errors}
                            isRequired={true}
                            isLoading={isLoading}
                          />
                        </div>
                        <div className="relative xs:w-full sm:w-1/2 lg:w-1/2 xs:mt-[18px]">
                          <Dropdown
                            control={control}
                            label={"Province / State"}
                            options={states}
                            name={"states"}
                            valueName="state"
                            valueoption="state_id"
                            rightIcon={Icons.arrowIcon}
                            selectedValue={select.states}
                            handleSelect={(value) =>
                              handleDropdwonSelect("states", value)
                            }
                            errors={errors}
                            isRequired={true}
                            isLoading={isLoadingStates}
                          />
                        </div>
                      </div>
                      <div
                        className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}
                      >
                        <div className="relative mt-[18px] w-full sm:w-11/12">
                          <Dropdown
                            control={control}
                            rightIcon={Icons.arrowIcon}
                            label={"City"}
                            options={cities}
                            selectedValue={select?.city}
                            handleSelect={(value) =>
                              handleDropdwonSelect("city", value)
                            }
                            valueName="city"
                            valueoption="city_id"
                            name={"city"}
                            errors={errors}
                            isRequired={true}
                            isLoading={citiesisLoading}
                          />
                        </div>
                        <div className="relative mt-[18px] w-full sm:w-11/12">
                          <Dropdown
                            control={control}
                            rightIcon={Icons.arrowIcon}
                            label={"Gender"}
                            options={dropdowns?.gender}
                            name={"gender"}
                            selectedValue={select.gender}
                            handleSelect={(value) =>
                              handleDropdwonSelect("gender", value)
                            }
                            valueName="gender"
                            valueoption="id"
                            isRequired={true}
                            isLoading={dropdownLoading}
                          />
                        </div>
                      </div>
                      <div
                        className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}
                      >
                        <div className="relative mt-[18px] w-full">
                          <label className="block text-base font-medium text-secondary mb-2">
                            Age
                          </label>

                          <div className="relative h-7" ref={sliderRefAge}>
                            {tooltipPosAge.map((pos, i) => (
                              <div
                                key={i}
                                className="absolute -top-7 transform -translate-x-1/2 text-white text-xs font-semibold px-2 py-1 rounded whitespace-nowrap bg-goldMetallic"
                                style={{ left: `${pos}%` }}
                              >
                                {rangeAge[i]} years
                                <div className="absolute left-1/2 top-full -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-goldMetallic" />
                              </div>
                            ))}
                          </div>

                          <RangeSlider
                            id="range-slider-height"
                            min={6}
                            max={90}
                            step={1}
                            value={rangeAge}
                            onInput={handleInputAge}
                            className="yellow-slider"
                          />

                          <style jsx>{`
                            .yellow-slider .range-slider__thumb {
                              background-color: #d4af37; /* goldMetallic */
                            }
                            .yellow-slider .range-slider__range {
                              background-color: #d4af37;
                            }
                          `}</style>
                        </div>
                      </div>
                      <div
                        className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}
                      >
                        <div className="relative mt-[18px] w-full">
                          <Dropdown
                            control={control}
                            rightIcon={Icons.arrowIcon}
                            label={"Ethnicity"}
                            options={dropdowns?.ethnicity}
                            name={"ethnicity"}
                            selectedValue={select.ethinicity}
                            handleSelect={(value) =>
                              handleDropdwonSelect("ethinicity", value)
                            }
                            valueName="name"
                            valueoption="ethnicity_id"
                            errors={errors}
                            isRequired={true}
                            isLoading={isLoading}
                          />
                        </div>
                      </div>
                      <div
                        className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}
                      >
                        <div className="relative mt-[18px] w-full sm:w-11/12">
                          <Dropdown
                            control={control}
                            rightIcon={Icons.arrowIcon}
                            label={"Hair Types"}
                            options={dropdowns?.hairTypes}
                            name={"hairTypes"}
                            selectedValue={select.hairTypes}
                            valueName="name"
                            valueoption="hair_type_id"
                            handleSelect={(value) =>
                              handleDropdwonSelect("hairTypes", value)
                            }
                            errors={errors}
                            isRequired={true}
                            isLoading={isLoading}
                          />
                        </div>
                        <div className="relative mt-[18px] w-full sm:w-11/12">
                          <Dropdown
                            control={control}
                            rightIcon={Icons.arrowIcon}
                            label={"Eye Colors"}
                            options={dropdowns?.eyeColors}
                            name={"eyeColors"}
                            selectedValue={select.eyeColors}
                            valueName="name"
                            valueoption="eye_color_id"
                            handleSelect={(value) =>
                              handleDropdwonSelect("eyeColors", value)
                            }
                            errors={errors}
                            isRequired={true}
                            isLoading={isLoading}
                          />
                        </div>
                      </div>
                      <div
                        className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}
                      >
                        <div className="relative mt-[18px] w-full">
                          <label className="block text-base font-medium text-secondary mb-2">
                            Height
                          </label>
                          <div className="relative h-7" ref={sliderRefHeight}>
                            {tooltipPosHeight.map((pos, i) => (
                              <div
                                key={i}
                                className="absolute -top-7 transform -translate-x-1/2 text-white text-xs font-semibold px-2 py-1 rounded whitespace-nowrap bg-goldMetallic"
                                style={{ left: `${pos}%` }}
                              >
                                {rangeHeight[i]} cm
                                <div className="absolute left-1/2 top-full -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-goldMetallic" />
                              </div>
                            ))}
                          </div>

                          <RangeSlider
                            id="range-slider-height"
                            min={120}
                            max={220}
                            step={1}
                            value={rangeHeight}
                            onInput={handleInputHeight}
                            className="yellow-slider"
                          />

                          <style jsx>{`
                            .yellow-slider .range-slider__thumb {
                              background-color: #d4af37; /* goldMetallic */
                            }
                            .yellow-slider .range-slider__range {
                              background-color: #d4af37;
                            }
                          `}</style>
                        </div>
                      </div>
                      <div
                        className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}
                      >
                        <div className="relative mt-[18px] w-full">
                          <div className="w-full text-white">
                            <label className="block xs:text-sm sm:text-base font-onestRegular text-secondary mb-1">
                              Weight
                            </label>
                            <div className="mt-4 relative">
                              <div
                                className="relative h-7"
                                ref={sliderRefWeight}
                              >
                                {tooltipPosWeight.map((pos, i) => (
                                  <div
                                    key={i}
                                    className="absolute -top-7 transform -translate-x-1/2 text-white text-xs font-semibold px-2 py-1 rounded whitespace-nowrap bg-goldMetallic"
                                    style={{ left: `${pos}%` }}
                                  >
                                    {rangeWeight[i]} kg
                                    <div className="absolute left-1/2 top-full -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-goldMetallic" />
                                  </div>
                                ))}
                              </div>

                              <RangeSlider
                                id="range-slider-yellow"
                                min={25}
                                max={200}
                                step={1}
                                value={rangeWeight}
                                onInput={handleInputWeight}
                                className="yellow-slider"
                              />
                              <style jsx>{`
                                .yellow-slider .range-slider__thumb {
                                  background-color: #d4af37; /* goldMetallic */
                                }
                                .yellow-slider .range-slider__range {
                                  background-color: #d4af37;
                                }
                              `}</style>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          "flex xs:flex-col w-full sm:gap-2 lg:gap-4 pt-2"
                        }
                      >
                        <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 xs:pt-1 lg:pt-2">
                          <CheckBoxSelection
                            control={control}
                            name="bodyTattoos"
                            mapitems={RadioValueandLable}
                            register={register}
                            errors={errors}
                            isRequired={false}
                            label="Body Modifications / Tattoos"
                          />
                        </div>
                        <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 xs:pt-1 lg:pt-1">
                          <CheckBoxSelection
                            control={control}
                            name="bodyPiercings"
                            mapitems={RadioValueandLable}
                            register={register}
                            errors={errors}
                            isRequired={false}
                            label="Body Modifications / Piercings"
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <Dropdown
                          control={control}
                          rightIcon={Icons.arrowIcon}
                          label={"Experience level"}
                          options={dropdowns?.experience}
                          valueName="job_experience"
                          valueoption="job_experience_id"
                          name={"experience"}
                          selectedValue={select.experienceLevel}
                          handleSelect={(value) =>
                            handleDropdwonSelect("experienceLevel", value)
                          }
                          errors={errors}
                          isRequired={true}
                          isLoading={isLoading}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Footer Buttons */}
                  <div className="py-2 w-full">
                    <div className="flex justify-end">
                      <Text
                        text="Reset Filters"
                        align="text-right hover:text-secondary transition-colors duration-300 ease-in-out"
                        className={"mt-2 mb-3 cursor-pointer w-fit"}
                        color="text-orangeCrayola"
                        size={fontSizes.h14}
                        onClick={resetFilters}
                        weight={TextWeight.Onest_regular}
                      />
                    </div>
                    <Button
                      text="Apply"
                      type={"submit"}
                      bgColor="bg-accepted"
                      color="text-secondary"
                      className="w-full rounded-full"
                      textSize={fontSizes.h16}
                      weight={TextWeight.Onest_regular}
                      loading={isLoading}
                      isDisabled={isLoading}
                    />
                  </div>
                </form>
              </div>
              <div className="pt-2.5 pb-5 sm:pt-5 sm:pb-10">
                {appliedJobData?.total_records > 10 && (
                  <div className="flex justify-end items-center pt-5">
                    <Pagination
                      setCurrentPage={setCurrentPage}
                      currentPage={currentPage}
                      total_pages={total_pages}
                      has_more_pages={has_more_pages}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmpApplicantsList;
